<template>
  <ul>
    <menu-options-item close label="Abrir" @click="$emit('abrir')" icon="folder-open" />
    <menu-options-item v-if="reboquista.active" close label="Desativar" @click="$emit('desativarAtivar')" icon="times" />
    <menu-options-item v-else close label="Reativar" @click="$emit('desativarAtivar')" icon="check" />
  </ul>
</template>

<script>
import MenuOptionsItem from '../../../layout/context-menu/context-window-options-item'
export default {
  name: 'reboquista-list-menu',
  props: ['reboquista'],
  components: {MenuOptionsItem}
}
</script>
